import React from 'react'
import OrbitMetadataManagement from '../../admin/OrbitMetadataManagement'
import V3PageBridgeFrame from '../V3PageBridgeFrame'

export default function V3OrbitMetadataManagementPage() {
  return (
    <V3PageBridgeFrame>
      <OrbitMetadataManagement />
    </V3PageBridgeFrame>
  )
}

